import styled from 'styled-components';
import { Badge, GhostButton, gtagEvent, vars } from '@agendor/ui';

const Wrapper = styled.nav`
    height: ${vars.navbarHeight};
    background-color: rgba(${vars.dangerTintSoftRgb}, 0.95);
    border-bottom: 1px solid ${vars.dividerColor};
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    top: 0;
    z-index: 10;
`;

const Content = styled.div`
    padding: 0 24px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 480px) {
        padding: 0 16px;
    }
`;

const Brand = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
`;

const BrandButton = styled(GhostButton).attrs({ hoverBg: 'bright' })`
    gap: 8px;
    font-weight: 600;
    font-size: 0.95rem;
    user-select: none;
    outline: none;

    & img {
        display: block;
    }
`;

const MenuButton = styled.button<{ isOpen: boolean }>`
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    gap: 6px;
    z-index: 20;

    @media (min-width: 769px) {
        display: none;
    }

    span {
        display: block;
        width: 24px;
        height: 2px;
        background-color: ${vars.foregroundColor};
        border-radius: 2px;
        transform-origin: center;
    }

    &:hover span {
        background-color: ${vars.accentColor};
    }
`;

const SupportLink = styled(GhostButton)`
    @media (max-width: 768px) {
        display: none;
    }
`;

interface NavbarProps {
    onMenuClick: () => void;
    onBrandClick: () => void;
    isOpen?: boolean;
}

export default function Navbar({ onMenuClick, onBrandClick, isOpen = false }: NavbarProps) {
    return (
        <Wrapper>
            <Content>
                <Brand>
                    <BrandButton
                        onClick={() => {
                            gtagEvent('navbar_brand_click');
                            onBrandClick();
                        }}
                        aria-label="OrganizaBot"
                    >
                        <img src="/logo_60x60.png" width="24" height="24" alt="OrganizaBot" />
                        <strong>OrganizaBot</strong>
                    </BrandButton>
                    <Badge>Business</Badge>
                </Brand>
                <SupportLink
                    as="a"
                    href="https://wa.me/5547984627950?text=Olá,%20preciso%20de%20ajuda%20com%20o%20painel%20Business%20do%20OrganizaBot."
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => gtagEvent('navbar_support_click')}
                >
                    Suporte
                </SupportLink>
                <MenuButton
                    onClick={() => {
                        gtagEvent('navbar_menu_click', { action: isOpen ? 'close' : 'open' });
                        onMenuClick();
                    }}
                    aria-label="Menu"
                    isOpen={isOpen}
                >
                    <span />
                    <span />
                    <span />
                </MenuButton>
            </Content>
        </Wrapper>
    );
}
